import { useEffect } from 'preact/hooks'
import { navigate, usePath, useRoutes } from 'raviger'

import config from '../utils/config'
import {
  peekReturnPath,
  rememberReturnPath,
  takeReturnPath
} from '../utils/return_path'
import { loadProfile, profile } from '../utils/session'
import { Home } from './home'
import { Login } from './login'
import { Play } from './play'
import { Reviews } from './reviews'
import { Welcome } from './welcome'

const routes = {
  '/': () => <Home />,
  '/login': () => <Login />,
  '/play': () => <Play />,
  '/reviews': () => <Reviews />,
  '/welcome': () => <Welcome />
}

// Where the current session is allowed to be; null means "anywhere
// the route table says".
function requiredPath(current, path) {
  if (current === null)
    return path === '/login' ? null : '/login'
  if (current.needsName)
    return path === '/welcome' ? null : '/welcome'
  if (path === '/login' || path === '/welcome')
    return '/'

  return null
}

export function App() {
  const path = usePath()
  const route = useRoutes(routes)
  const current = profile.value

  useEffect(() => {
    loadProfile()
  }, [])

  useEffect(() => {
    if (current === undefined)
      return
    const target = requiredPath(current, path)
    if (target === '/login')
      rememberReturnPath(path)
    if (target) {
      navigate(target, { replace: true })
      return
    }
    if (current && !current.needsName) {
      const back = takeReturnPath()
      if (back && back !== path)
        navigate(back, { replace: true })
    }
  }, [current, path])

  if (current === undefined)
    return null
  if (requiredPath(current, path))
    return null
  const back = current && !current.needsName && peekReturnPath()
  if (back && back !== path)
    return null

  return (
    <>
      {route || <Home />}
      <footer class="build">
        {config.envName} · {config.version} · {config.buildDate}
      </footer>
    </>
  )
}
